// extracted by mini-css-extract-plugin
export var clauseRow = "_a1-6";
export var emptyState = "_a1-b";
export var filterContent = "_a1-a";
export var filterGroup = "_a1-1";
export var filterGroupContainer = "_a1-0";
export var nestedGroup = "_a1-2";
export var nestedGroupDepth1 = "_a1-3";
export var nestedGroupDepth2 = "_a1-4";
export var nestedGroupDepth3 = "_a1-5";
export var operatorAnd = "_a1-8";
export var operatorOr = "_a1-9";
export var operatorToggle = "_a1-7";
export var removeGroupButton = "_a1-c";